
import React, { Component, Fragment } from 'react';
import { Container, Row, Col, } from 'react-bootstrap';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import TwitterIcon from '@material-ui/icons/Twitter';
import logo from '../../../assets/images/oneroof-logo.svg';

const Footer = (props) => {

 return (
        <Fragment>
           <div className="black-bg mt-4 footer">
                <Container>
                    <Row>
                        <Col md={4}>
                        <img src={logo} alt="oneroof" className="company-logo" />
                        <p className="mt-2">© 2020 One Roof Pte. Ltd. All Right Reserved. </p>
                        <p>The One Roof wordmark is a registered trademark of One Roof Pte Ltd. Selected products and brands are copyrights and
                        trademarks of their respective owners.  </p>

                        <p>Unauthorised use of content from this site is prohibited.</p>
                        </Col>
                        <Col md={4}>
                            <p><FacebookIcon fontSize="large" 
                            className="mr-2"
                            />
                            <InstagramIcon fontSize="large"  className="mr-2"/>
                            <TwitterIcon  fontSize ="large" /></p>
                            <p>OneRoof.sg was established to make your life easier. It is the place where you can get all your furniture needs met at once, make product and price comparisons at a glance and enhance your overall furniture shopping experience. </p>

                            <p>Creativity for sustainability is at the heart of what we do as we create a livelier furnishing market.</p>
                            

                        </Col>
                        <Col md={4}>
                            <p className="footer-header">Company</p>
                            <ul>
                                <li>About </li>
                                <li>Living Tips  </li>
                                <li>Contact Us</li>
                            </ul>

                        </Col>
                    </Row>
                </Container>

            </div>
        </Fragment>

    );
}
export default Footer;